import type { WorldState } from "./models/worldState.ts";

function deepFreeze<T>(value: T): T {
  if (value === null || typeof value !== "object") {
    return value;
  }
  if (Object.isFrozen(value)) {
    return value;
  }

  for (const child of Object.values(value as object)) {
    deepFreeze(child);
  }

  return Object.freeze(value);
}

/** Deep-freeze the world snapshot so hosts cannot mutate store state in place. */
export function freezeWorldState(state: WorldState): WorldState {
  return deepFreeze(state);
}
